module.exports = __webpack_public_path__ + "static/media/letuska.7fbc9e4f.png";